import React from 'react'
import PropTypes from 'prop-types'
import cssModules from 'react-css-modules'
import styles from './checkbox.less'

class Checkbox extends React.Component {
  static propTypes = {
    name: PropTypes.string,
    label: PropTypes.string,
    onChange: PropTypes.func,
    value: PropTypes.bool,
    description: PropTypes.string,
    disabled: PropTypes.bool,
    smallText: PropTypes.bool,
    dataNemo: PropTypes.string,
    'data-pa-click': PropTypes.string,
  }

  render() {
    let classes = ['checkbox']
    if (this.props.disabled) {
      classes.push('disabled')
    }
    if (this.props.smallText) {
      classes.push('small')
    }
    return (
      <div>
        <div styleName={classes.join(' ')}>
          <input
            type="checkbox"
            disabled={this.props.disabled}
            id={this.props.name}
            onChange={this.props.onChange}
            checked={this.props.value}
            data-pa-click={this.props['data-pa-click']}
            data-nemo={this.props['data-pa-click']}
          />
          <label htmlFor={this.props.name} data-nemo={this.props.dataNemo}>
            <div>{this.props.label}</div>
          </label>
        </div>
        {this.props.description && (
          <p styleName="description">{this.props.description}</p>
        )}
      </div>
    )
  }
}

export default cssModules(Checkbox, styles, { allowMultiple: true })
